$(window).scroll(function () {
  let scrolled = $(window).scrollTop(),
    marquee_height = $(".header_marquee").height(),
    header_height = $(".header").height(),
    normalize = $(window).width() <= 900 ? 60 : 100;

  if (scrolled > marquee_height + header_height) {
    $(".header").addClass("_scrolled");
  } else {
    $(".header").removeClass("_scrolled");
  }
});

const search = document.querySelector(".mobile_menu_search");

const handleElementAppearance = (element) => {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "style"
      ) {
        const computedStyle = window.getComputedStyle(element);
        const displayProp =
          computedStyle.getPropertyValue("display") === "none";

        displayProp
          ? document.body.classList.remove("no_scroll")
          : document.body.classList.add("no_scroll");
      }
    }
  });

  const config = { attributes: true, attributeFilter: ["style"] };

  observer.observe(element, config);
};

const targetElement = document.querySelector(".snize-ac-results-mobile");

const appearanceObserver = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches(".snize-ac-results-mobile")) {
          handleElementAppearance(node);
        }
      });
    }
  }
});

const appearanceConfig = { childList: true, subtree: true };

appearanceObserver.observe(document.body, appearanceConfig);

let scrollPos = 0;

const stickySearch = (e) => {
  let curPos = e.currentTarget.scrollY;

  if (curPos <= 150) {
    search.classList.remove("hide");

    return;
  } else {
    if (curPos > scrollPos) {
      search.classList.add("hide");
    } else {
      search.classList.remove("hide");
    }
  }

  scrollPos = curPos;
};

window.addEventListener("scroll", stickySearch, { passive: true });
window.addEventListener("load", stickySearch);
window.addEventListener("resize", stickySearch);

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) == 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

const headerTopTimes = document.querySelector(".header_marquee_times") || null;
const header = document.querySelector(".header");
const main = document.querySelector(".main");

headerTopTimes &&
  headerTopTimes.addEventListener("click", () => {
    const headerTopHeight = headerTopTimes.parentElement.offsetHeight;
    const mainStyle = window.getComputedStyle(main);
    const mainSpace = parseInt(mainStyle.getPropertyValue("padding-top"));

    header.style.top = 0;
    headerTopTimes.parentElement.classList.add("hidden");
    main.style.transition = ".3s ease all";
    main.style.paddingTop = `${mainSpace - headerTopHeight}px`;
    // setCookie("headerClosed", "true", 30)
  });

// if (getCookie('headerClosed')) {
//   const header = document.querySelector('.header')
//   const overlay = document.querySelector('.menu_overlay')
//   const main = document.querySelector('.main')
//   const headerTop = document.querySelector('.header_marquee')
//   const headerTopHeight = headerTop.offsetHeight
//   const mainStyle = window.getComputedStyle(main)
//   const mainSpace = parseInt(mainStyle.getPropertyValue('padding-top'))

//   headerTop.style.display = 'none'
//   header.style.top = 0
//   overlay.style.top = 0
//   header.style.transition = 'none'
//   header.style.zIndex = 999999
//   main.style.paddingTop = `${mainSpace - headerTopHeight}px`

//   setTimeout(() => {
//     header.style.transition = ''
//     header.style.zIndex = ''
//   }, 500)
// }

let rem = ($(window).width() * 0.0104167).toFixed(2);

$(window).resize(function () {
  rem = ($(window).width() * 0.0104167).toFixed(2);
});

$(document).ready(function () {
  $(document).on("click", ".header_drop_title", function (e) {
    e.preventDefault();
    $(this).closest(".header_drop").toggleClass("_active");
  });

  $(document).on("click", "[data-open-menu]", function (e) {
    e.preventDefault();
    // $("body").addClass("no_scroll");
    // $(".menu_overlay").addClass("_active");
    // $("#main_menu").addClass("_active");
    const text = $(this).text().trim().toLowerCase();

    $("#menu_btn").click();

    $(".main-menu__text").each(function () {
      if ($(this).text().trim().toLowerCase() === text) {
        $(this).parent().click();
      }
    });
  });

  $(document).on("click", "#menu_btn", function (e) {
    e.preventDefault();
    $("body").addClass("no_scroll");
    $(".menu_overlay").addClass("_active");
    $("#mobile_menu").addClass("_active");
  });

  $(document).on("click", ".mobile_menu li[data-mob-menu]", function (e) {
    e.preventDefault();
    let mob_sub_menu = $(this).data("mob-menu");
    $('.mobile_menu_subcats[data-mob-menu="' + mob_sub_menu + '"]').addClass(
      "_active"
    );
  });

  $(document).on("click", ".mobile_menu_subcats ._close", function (e) {
    e.preventDefault();
    $(this).closest(".mobile_menu_subcats").removeClass("_active");
  });

  $(document).on(
    "click",
    ".main_menu_close, .menu_overlay, .mobile_menu_close, .mobile_menu_close svg",
    function (e) {
      e.preventDefault();
      $("body").removeClass("no_scroll");
      $(".menu_overlay").removeClass("_active");
      $("#main_menu").removeClass("_active");
      $("#mobile_menu").removeClass("_active");
      $(".mobile_menu_subcats._active").removeClass("_active");

      setTimeout(() => {
        $(".main-menu__item--has-children.open").removeClass("open");
        $(".main-menu__block").get(0).style = "";
        $(".mobile_menu_close").get(0).style = "";
      }, 500);
    }
  );

  $(document).on("click", ".mob_drop_title", function (e) {
    e.preventDefault();
    $(this).closest(".mob_drop").toggleClass("_active");
  });

  $(document).on("click", ".footer_drop-icon", function (e) {
    e.preventDefault();
    $(this).closest(".footer_drop").toggleClass("_active");
  });

  $(document).on("click", "[data-open-cart]", function (e) {
    e.preventDefault();
    $("body").addClass("no_scroll");
    $(".cart_overlay").addClass("_active");
    $("#popup_cart").addClass("_active");
  });
  $(document).on(
    "click",
    ".popup_cart_close,.popup_cart_close svg, .cart_overlay",
    function (e) {
      e.preventDefault();
      $("body").removeClass("no_scroll");
      $(".cart_overlay").removeClass("_active");
      $("#popup_cart").removeClass("_active");
    }
  );

  $(document).on("click", ".header_currency_title", function (e) {
    $(this).closest(".header_currency").toggleClass("_open");
  });

  // currency list buttons

  let step = 30;
  let scrolling = false;

  $("#header_currency_nav_top").bind("click", function (event) {
    event.preventDefault();
    $("#header_currency_list").animate({
      scrollTop: "-=" + step + "px",
    });
  });

  $("#header_currency_nav_bottom").bind("click", function (event) {
    event.preventDefault();
    $("#header_currency_list").animate({
      scrollTop: "+=" + step + "px",
    });
  });

  function scrollContent(direction) {
    let amount = direction === "up" ? "-=1px" : "+=1px";
    $("#header_currency_list").animate(
      {
        scrollTop: amount,
      },
      1,
      function () {
        if (scrolling) {
          scrollContent(direction);
        }
      }
    );
  }

  // end currency list buttons

  //Change currency
  $("[data-currency-item]").on("click", (e) => {
    const selectedCurrency = $(e.target).data("val");

    $.ajax({
      url: "/cart/update/",
      method: "POST",
      data: {
        form_type: "currency",
        return_to: $('input[name="return_to"]').val(),
        currency: selectedCurrency,
        utf8: "✓",
      },
      success: function (data) {
        window.location = $('input[name="return_to"]').val();
      },
    });
  });
  //Change currency

  //Category
  $(document).on("click", "#toggle_category_desciption", function (e) {
    e.preventDefault();
    if ($(this).hasClass("_active")) {
      $(this)
        .text($(this).data("more"))
        .removeClass("_active")
        .closest(".category_head_content")
        .find(".category_head_description")
        .removeClass("_active");
    } else {
      $(this)
        .text($(this).data("less"))
        .addClass("_active")
        .closest(".category_head_content")
        .find(".category_head_description")
        .addClass("_active");
    }
  });

  $(document).on("click", ".faq_item_title", function (e) {
    e.preventDefault();
    if ($(this).hasClass("_active")) {
      $(this).removeClass("_active").next(".faq_item_content").slideUp();
    } else {
      // All slide close and first open
      //$(this).addClass("_active").next(".faq_item_content").slideUp();
      //$(".faq_item_title._active")
      //  .removeClass("_active")
      //  .next(".faq_item_content")
      //  .slideUp();
      $(this).addClass("_active").next(".faq_item_content").slideDown();
    }
  });

  $(document).on("click", ".category_sorts_title", function (e) {
    e.preventDefault();
    if ($(this).closest(".category_sorts").hasClass("_active")) {
      $(this).closest(".category_sorts").removeClass("_active");
    } else {
      $(this).closest(".category_sorts").addClass("_active");
    }
  });

  //  PRODUCT PAGE

  if ($("#product_main_gallery").length) {
    let swiperProps = {};

    if (innerWidth >= 901) {
      swiperProps = {
        spaceBetween: 16,
        slidesPerView: 1.35,
        direction: "vertical",
        grabCursor: true,
        mousewheel: true,
        freeMode: true,
        navigation: {
          nextEl: "#product_main_gallery .swiper-button-next",
          prevEl: "#product_main_gallery .swiper-button-prev",
        },
        scrollbar: {
          el: ".gallery-scrollbar",
          draggable: true,
        },
        breakpoints: {
          901: {
            direction: "vertical",
            spaceBetween: 16,
            slidesPerView: 1.35,
          },
          0: {
            direction: "horizontal",
            spaceBetween: 20,
            slidesPerView: 1,
          },
        },
      };
    } else {
      swiperProps = {
        spaceBetween: 16,
        slidesPerView: 1.35,
        direction: "vertical",
        grabCursor: false,
        mousewheel: false,
        freeMode: false,
        navigation: {
          nextEl: "#product_main_gallery .swiper-button-next",
          prevEl: "#product_main_gallery .swiper-button-prev",
        },
        scrollbar: {
          el: ".gallery-scrollbar",
          draggable: true,
        },
        breakpoints: {
          901: {
            direction: "vertical",
            spaceBetween: 16,
            slidesPerView: 1.35,
          },
          0: {
            direction: "horizontal",
            spaceBetween: 20,
            slidesPerView: 1,
          },
        },
      };
    }
    let product_main_gallery = new Swiper(
      "#product_main_gallery .swiper-container",
      swiperProps
    );
  }

  $(document).on("click", ".product_fixed_nav_item[data-anchor]", function (e) {
    e.preventDefault();

    let position =
      $($(this).data("anchor")).offset().top -
      $("#product_fixed").height() -
      30;

    if ($(window).width() <= 900) {
      $("html, body").animate(
        {
          scrollTop: position - 20,
        },
        400
      );
    } else {
      $("html, body").animate(
        {
          scrollTop: position - 30,
        },
        400
      );
    }
  });

  $(window).scroll(function () {
    if ($("#product_fixed").length) {
      let scroll_top = $(window).scrollTop(),
        // product_wrap = $("#product_main_wrap").offset().top,
        product_wrap = $(".product_main .product_main_actions").offset().top,
        fixed_height = $("#product_fixed").height();

      if (scroll_top >= product_wrap) {
        $("#product_fixed").addClass("_active");
        $("#product_main_wrap").addClass("_scrolled");
        $(".header").addClass("_scrolled_hide");
      } else {
        $("#product_fixed").removeClass("_active");
        $("#product_main_wrap").removeClass("_scrolled");
        $(".header").removeClass("_scrolled_hide");
      }
    }
  });

  $(document).on("click", "[data-open-popup-sizes]", function (e) {
    e.preventDefault();
    $("body").addClass("no_scroll");
    $(".sizes_overlay").addClass("_active");
    $("#sizes_popup").addClass("_active");
  });
  $(document).on(
    "click",
    ".sizes_popup_close, .sizes_popup_close svg, .sizes_overlay",
    function (e) {
      e.preventDefault();
      $("body").removeClass("no_scroll");
      $(".sizes_overlay").removeClass("_active");
      $("#sizes_popup").removeClass("_active");
    }
  );

  $(document).on("click", "#sizes_popup .sizes_list_item", function (e) {
    e.preventDefault();

    let size = $(this).data("size");

    if (!$(this).hasClass("_active")) {
      $("#sizes_popup .sizes_list_item._active").removeClass("_active");
      $(this).addClass("_active");
      $("#sizes_popup  .attributes_list.attributes_list").removeClass(
        "_active"
      );
      $('#sizes_popup  .attributes_list[data-size="' + size + '"]').addClass(
        "_active"
      );
    }
  });

  $(document).on("click", "#sizes_popup .unit_list_item", function (e) {
    e.preventDefault();

    let unit = $(this).data("unit");

    if (!$(this).hasClass("_active")) {
      $(this)
        .closest(".attributes_list")
        .find(".attribute_item")
        .removeClass("_active");
      $(this)
        .closest(".attributes_list")
        .find('.attribute_item[data-unit="' + unit + '"]')
        .addClass("_active");

      $(this)
        .closest(".attributes_list")
        .find(".unit_list_item._active")
        .removeClass("_active");
      $(this).addClass("_active");
    }
  });

  if (
    $("#size_guide_sizes_extra").length &&
    $("#size_guide_sizes_extra").find(".sizes_list_item").length
  ) {
    let size_guide_sizes_extra = $("#size_guide_sizes_extra").html();
    $(".sizes_list_inner").append(size_guide_sizes_extra);
    $("#size_guide_sizes_extra").remove();
  }

  if (
    $("#sizes_guide_img_extra").length &&
    $("#sizes_guide_img_extra").find("img").length
  ) {
    let sizes_guide_img_extra = $("#sizes_guide_img_extra").html();
    $("#sizes_guide_img").append(sizes_guide_img_extra);
    $("#sizes_guide_img_extra").remove();
  }
  if (
    $("#sizes_guide_list_extra").length &&
    $("#sizes_guide_list_extra").find(".attributes_list").length
  ) {
    let sizes_guide_list_extra = $("#sizes_guide_list_extra").html();
    $("#sizes_guide_list").append(sizes_guide_list_extra);
    $("#sizes_guide_list_extra").remove();
  }
  if (
    $("#size_guide_sizes_extra_2").length &&
    $("#size_guide_sizes_extra_2").find(".sizes_list_item").length
  ) {
    let size_guide_sizes_extra_2 = $("#size_guide_sizes_extra_2").html();
    $(".sizes_list_inner").append(size_guide_sizes_extra_2);
    $("#size_guide_sizes_extra_2").remove();
  }
  if (
    $("#sizes_guide_img_extra_2").length &&
    $("#sizes_guide_img_extra_2").find("img").length
  ) {
    let sizes_guide_img_extra_2 = $("#sizes_guide_img_extra_2").html();
    $("#sizes_guide_img").append(sizes_guide_img_extra_2);
    $("#sizes_guide_img_extra_2").remove();
  }
  if (
    $("#sizes_guide_list_extra_2").length &&
    $("#sizes_guide_list_extra_2").find(".attributes_list").length
  ) {
    let sizes_guide_list_extra_2 = $("#sizes_guide_list_extra_2").html();
    $("#sizes_guide_list").append(sizes_guide_list_extra_2);
    $("#sizes_guide_list_extra_2").remove();
  }

  // Check if empty
  if (!$(".sizes_list_inner").find("*").length) {
    $(".sizes_list").remove();
    $(".attributes_wrap").remove();
  } else {
    // Check width to remove scrollbar
    $(".sizes_list_inner > *").first().click();

    $(window).on("load resize", function () {
      if (
        $(".sizes_list_inner").get(0).offsetWidth >=
        $(".sizes_list_inner").get(0).scrollWidth
      ) {
        $(".sizes_list_scrollbar").remove();
        $(".sizes_list").addClass("no-scroll");
      }
    });
  }

  if ($(".brands__item").length) {
    $(".brands__item").each(function () {
      if (!$(this).find(".brands__item-text").length) {
        $(this).remove();
      }
    });
  }

  setTimeout(function () {
    if ($("#snize_results.snize-search-results .snize-header").length) {
      $("#snize_results.snize-search-results .snize-header").append(
        '<div id="search_filters_btn" class="category_filters_btn"> <div>Add filter</div> <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"> <path d="M16.5 27C16.075 27 15.7185 26.856 15.4305 26.568C15.1425 26.28 14.999 25.924 15 25.5C15 25.075 15.144 24.7185 15.432 24.4305C15.72 24.1425 16.076 23.999 16.5 24H19.5C19.925 24 20.2815 24.144 20.5695 24.432C20.8575 24.72 21.001 25.076 21 25.5C21 25.925 20.856 26.2815 20.568 26.5695C20.28 26.8575 19.924 27.001 19.5 27H16.5ZM6.00001 12C5.57501 12 5.21851 11.856 4.93051 11.568C4.64251 11.28 4.49901 10.924 4.50001 10.5C4.50001 10.075 4.64401 9.71851 4.93201 9.43051C5.22001 9.14251 5.57601 8.99901 6.00001 9.00001H30C30.425 9.00001 30.7815 9.14401 31.0695 9.43201C31.3575 9.72001 31.501 10.076 31.5 10.5C31.5 10.925 31.356 11.2815 31.068 11.5695C30.78 11.8575 30.424 12.001 30 12H6.00001ZM10.5 19.5C10.075 19.5 9.71851 19.356 9.43051 19.068C9.14251 18.78 8.99901 18.424 9.00001 18C9.00001 17.575 9.14401 17.2185 9.43201 16.9305C9.72001 16.6425 10.076 16.499 10.5 16.5H25.5C25.925 16.5 26.2815 16.644 26.5695 16.932C26.8575 17.22 27.001 17.576 27 18C27 18.425 26.856 18.7815 26.568 19.0695C26.28 19.3575 25.924 19.501 25.5 19.5H10.5Z" fill="white"></path> </svg> </div>'
      );
    }
  }, 1000);

  $(document).on("click", "#search_filters_btn", function () {
    $("body").addClass("no_scroll");
    $(".snize-filters-sidebar.snize-product-filters").addClass("_active");
    $(".filters_overlay").addClass("_active");
  });

  $(document).on("click", "a.brands__nav-item", function (e) {
    e.preventDefault();
    let position = $($(this).attr("href")).offset().top - 100;
    $("html, body").animate(
      {
        scrollTop: position,
      },
      550
    );
  });
});

$(document).mouseup(function (e) {
  let header_currency = $(".header_currency._open");
  if (
    !header_currency.is(e.target) &&
    header_currency.has(e.target).length === 0
  ) {
    $(".header_currency._open").removeClass("_open");
  }

  let mob_drop = $(".mob_drop._active");
  if (!mob_drop.is(e.target) && mob_drop.has(e.target).length === 0) {
    $(".mob_drop._active").removeClass("_active");
  }

  let category_sorts = $(".category_sorts._active");
  if (
    !category_sorts.is(e.target) &&
    category_sorts.has(e.target).length === 0
  ) {
    $(".category_sorts._active").removeClass("_active");
  }

  let open_quantity = $(".quantity_dropdown._open");
  if (!open_quantity.is(e.target) && open_quantity.has(e.target).length === 0) {
    $(".quantity_dropdown._open").removeClass("_open");
  }

  let footer_lang = $(".footer_drop._active");
  if (footer_lang.length > 0) {
    footer_lang.removeClass("_active");
  }
});
